export class UserHasNoPaymentMethods extends Error {
  constructor() {
    super('User has no saved payment methods')
    Object.setPrototypeOf(this, UserHasNoPaymentMethods.prototype)
  }
}
